// extracted by mini-css-extract-plugin
module.exports = {"badgesWrap":"Badges_badgesWrap__ive7H","badge":"Badges_badge__qM5JW","slide-in-out":"Badges_slide-in-out__Xxixu","fade-in-out":"Badges_fade-in-out__vkaGu"};